export default "__VITE_ASSET__DF_$5i8n__"